import { useSelector } from "@xstate/store/react";

import { type CellInfo } from "~/state/types";

import { cellsStore } from "./cells.store";

export const useCellNames = (): string[] => {
	const cells = useSelector(cellsStore, (state) => state.context.cells);

	return Object.values(cells)
		.map((cell) => cell.cell.cellName ?? undefined)
		.filter((cellName) => cellName !== undefined);
};

export const useSendToCellsStore = () => cellsStore.send;

export const useSelectOrderedCells = (): CellInfo[] => {
	const orderedList = useSelector(cellsStore, (state) => state.context.orderedList);
	const cells = useSelector(cellsStore, (state) => state.context.cells);

	return orderedList.map((id) => cells[id]).filter((cell) => cell !== undefined);
};

export const useSelectAllCellsReady = (): boolean => {
	const cells = useSelector(cellsStore, (state) => state.context.cells);

	return Object.values(cells).every((cell) => cell.status !== "initializing");
};
